import { createRouter, createWebHistory } from "vue-router";

const router = createRouter({
  history: createWebHistory("/"),
  routes: [
    {
      path: "/",
      name: "Home",
      component: () => import("../views/HomeView.vue"),
    },
    {
      path: "/about-us",
      name: "AboutUs",
      component: () => import("../views/AboutUs.vue"),
    },
    {
      path: "/careers",
      name: "Careers",
      component: () => import("../views/Careers.vue"),
    },
    {
      path: "/case-studies",
      name: "CaseStudies",
      component: () => import("../views/CaseStudies.vue"),
    },
    {
      path: "/terms-conditions",
      name: "TermsConditions",
      component: () => import("../views/TermsConditions.vue"),
    },
    {
      path: "/privacy-policy",
      name: "PrivacyPolicy",
      component: () => import("../views/PrivacyPolicy.vue"),
    },
    {
      path: "/fulfillment-policy",
      name: "FulfillmentPolicy",
      component: () => import("../views/FulfillmentPolicy.vue"),
    },
    {
      path: "/blog",
      name: "Blog",
      component: () => import("../views/Blog.vue"),
    },
    {
      path: "/webinar",
      name: "Webinar",
      component: () => import("../views/Webinar.vue"),
    },
    {
      path: "/responsible-ai",
      name: "ResponsibleAI",
      component: () => import("../views/ResponsibleAI.vue"),
    },

    {
      path: "/services",
      name: "Services",
      component: () => import("../views/ServicesView.vue"),
    },
    {
      path: "/product-theia",
      name: "ProductTheia",
      component: () => import("../views/ProductTheia.vue"),
    },

    {
      path: "/book-demo-theia",
      name: "BookDemoTheia",
      component: () => import("../views/DemoTheia.vue"),
    },

    {
      path: "/ai-ready",
      name: "AiReady",
      component: () => import("../views/AiReady.vue"),
    },

    {
      path: "/partners",
      name: "Partners",
      component: () => import("../views/PartnersView.vue"),
    },
    {
      path: "/contact-us",
      name: "ContactUs",
      component: () => import("../views/ContactUs.vue"),
    },

    {
      path: "/maritime-esign",
      name: "MaritimeEsign",
      component: () => import("../views/MaritimeEsign.vue"),
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    // Always scroll to top when navigating to a new page
    if (savedPosition) {
      return savedPosition; // Restore scroll position if using browser's forward/back buttons
    } else {
      return { left: 0, top: 0 }; // Scroll to top-left of the page
    }
  },
});

export default router;
